const FULL_DATE = 'DD/MM/YYYY'
const FULL_DATE_WITH_TIME = 'DD/MM/YYYY H:mm:ss'
const MINUTE_WITH_SEC = 'm:ss'
const FULL_DATE_WITH_TIME_HYPHEN = 'DD-MM-YYYY H:mm:ss'
const FULL_DATE_WITH_MINUTE = 'DD/MM/YYYY H:mm'

export default {
  FULL_DATE,
  FULL_DATE_WITH_TIME,
  MINUTE_WITH_SEC,
  FULL_DATE_WITH_TIME_HYPHEN,
  FULL_DATE_WITH_MINUTE
}
